import { Component, Input, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { BankOption } from '@core/model/domain/bank';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { StoreService } from '@shared/services/store.service';
import { assert } from 'ts-essentials';
import { TrackerService } from '@shared/services/tracker.service';

@Component({
  selector: 'app-regional-bank',
  templateUrl: './regional-bank.component.html',
  standalone: true,
  imports: [FormsModule, TranslateModule],
})
export class RegionalBankComponent {
  private readonly storeService = inject(StoreService);
  @Input() regionalBanks!: BankOption[];
  readonly bank = this.storeService.selectOrThrow('SELECTED_BANK');

  constructor(
    private readonly processEventService: ProcessEventService,
    private readonly tracker: TrackerService
  ) {}

  selectRegionalBank(option: BankOption) {
    const bank = this.bank();
    assert(bank.form[0], 'Bank form should not be empty');

    if (bank.authMechanism === 'credentials') {
      this.processEventService.push(
        ProcessEventFactory.SpawnCredentialsAuthentication({
          form: [{ name: option.name, value: option.value }],
          selectedBank: bank,
        })
      );
      return;
    }

    const name = option.name;
    const websiteUrl = option.value;
    const fieldName = bank.form[0].name;

    this.processEventService.push(
      ProcessEventFactory.SpawnWebauthWithRegionalBank({ fieldName, name, websiteUrl })
    );

    this.tracker.trackClick({ click: option.name, taggingPage: 'SELECT_REGIONAL_BANK' });
  }
}
